import TextBubbleDoughnut from "./Charts/TextBubbleDoughnut";
import { SentimentConfig, SentimentKeyword, TextBubbleAnalysis } from "../models/sentiment.model";
import TextAnalysisSentimentsDrawer from "./TextAnalysisSentimentsDrawer";
import { getUrlParam } from "../lib/helper";
import { CircularProgress, Stack } from "@mui/material";

export default function RandomBubble(props: { data: TextBubbleAnalysis[]; config?: SentimentConfig; loading?: boolean }) {
  const { data, config, loading } = props;
  const mobile = getUrlParam("mobile");

  const handleBubbleClick = async (keyword: SentimentKeyword) => {
    window.webApp.toggleDrawer({
      title: keyword.label,
      element: <TextAnalysisSentimentsDrawer keyword={keyword} config={config} />,
      minWidth: !mobile ? 1200 : 0,
      width: !mobile ? undefined : "100vw",
      open: true,
      onOk: async () => {
        console.log("onOk");
      },
      onCancel: async () => {
        console.log("onCancel");
      },
    });
  };

  return (
    <div
      style={{
        maxWidth: "100%",
        overflow: "auto",
      }}
    >
      <div className="relative height-100p" style={{ minHeight: 600, minWidth: 800 }}>
        {loading ? (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100%"
          >
            <CircularProgress size={24} />
          </Stack>
        ) : data.map((c) => (
          <div
            key={c.keyword.label}
            className="text-bubble-doughnut"
            style={{
              left: `${c.position.left}%`,
              top: `${c.position.top}%`,
              cursor: "pointer",
            }}
            onClick={() => handleBubbleClick(c.keyword)}
          >
            <TextBubbleDoughnut
              key={c.keyword.label}
              yes={c.keyword.positive}
              no={c.keyword.negative}
              neu={c.keyword.neutral}
              title={c.keyword.label}
              width={c.position.width}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
